import * as React from 'react';
import { useLoginOnStartup } from '@micro-frontend-react/employee-experience/lib/useLoginOnStartup';

interface AuthProps {
    children: React.ReactNode;
}

// Compile-time constant injected by Vite `define` (see vite.config.ts): `true` only
// under `vite -m itest`, the literal `false` in dev/prod builds. Minification then
// strips the auth-bypass path so it never ships in production.
declare const __IS_INTEGRATION_TESTING__: boolean;

export const Auth: React.FC<AuthProps> = ({ children }) => {
    const [user] = useLoginOnStartup(!__IS_INTEGRATION_TESTING__);
    const [isLoggedIn, setIsLoggedIn] = React.useState(__IS_INTEGRATION_TESTING__);

    React.useEffect(() => {
        if (user) {
            setIsLoggedIn(true);
        }
    }, [user]);

    return <>{isLoggedIn ? children : <div role="status" aria-live="polite">Logging in...</div>}</>;
};
